import { css } from '@emotion/react';
import IconEye from '~icons/bi/eye';
import IconEyeSlash from '~icons/bi/eye-slash';
import { theme } from '@arc/frontend/ui-theme';
const iconStyle = /*#__PURE__*/css({
  color: theme.colors.lightBlue,
  marginLeft: '0.5rem',
  cursor: 'pointer'
}, process.env.NODE_ENV === "production" ? "" : ";label:iconStyle;");
export function VisibilityToggle({
  visible,
  setVisible,
  inputRef,
  className
}) {
  return <button type="button" onClick={() => {
    setVisible(!visible);
    const input = inputRef?.current;
    if (input) {
      input.focus();
      setTimeout(() => {
        // move cursor to end of input
        input.selectionStart = input.selectionEnd = input.value.length;
      });
    }
  }} css={iconStyle} className={className}>
			{visible ? <IconEyeSlash width={22} height={22} /> : <IconEye width={22} height={22} />}
		</button>;
}